/**
 * Price formatting for Lao Kip (Lak) – thousand separators, optional currency suffix.
 * Use for display only (e.g. tables, labels); keep inputs numeric.
 */

const LAK_FORMATTER = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

export type FormatPriceLakOptions = {
  /** Append " ₭" (Lao Kip symbol) to the formatted value */
  suffix?: boolean;
};

/**
 * Format a number as Lao Kip with thousand separators (e.g. 15000 → "15,000").
 * Non-finite values return "—" so tables never show "NaN".
 *
 * @example
 * formatPriceLak(15000); // "15,000"
 * formatPriceLak(15000, { suffix: true }); // "15,000 ₭"
 */
export function formatPriceLak(
  value: number,
  options?: FormatPriceLakOptions,
): string {
  if (!Number.isFinite(value)) return "—";
  const formatted = LAK_FORMATTER.format(Math.round(value));
  return options?.suffix ? `${formatted} ₭` : formatted;
}
